import axios from "axios";

// baseURL will be set dynamically in AppProvider

export const api = axios.create({
    baseURL: '',
    timeout: 10000, // 10 seconds timeout
})

// Centralized error handling
api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        return Promise.reject(error);
    }
);

//export const domain = 'http://localhost:3000/'
//export const domain = 'https://prefeituraitajai-69ed6.web.app/'
//export const domain = config.domain_url
/*
Publicacoes: 'lista-download/',
CategoriaDownload: 'categoria-download/lista/',
ArquivoDownload: 'arquivo-download/categoria/',
*/

export const urls = {
    ListNews: 'noticias/ordem/recente/',
    ListNewsDestaquesHome: 'noticias',
    ListCategories: 'categorias',
    NewsById: 'noticia/cod_noticia/',
    NewsByCategorie: 'noticias/cod_categoria/',
    NewsByPage: 'noticias/pagina/',
    Services: 'servicos',
    Banners: 'banners',
    Notices: 'banner-fixo',
    videosDestaque: 'videos-destaque',
    VideosObject: 'videos',
    menus: 'menus',
    Pesquisa: 'pesquisa/termo/',
    Article: 'artigo/cod_artigo/',
    Entity: 'entidade/cod_entidade/',
    AcessoRapido: 'acesso-rapido',
    Modal: 'modal',
    Publicacoes: 'lista-download/',
    CategoriaDownload: 'categoria-download/lista/',
    ArquivoDownload: 'arquivo-download/categoria/',
}